// import axios from '@cloudpivot/common/src/mobile/config/axios';
import axios from 'axios';
export default axios;
